import { useContext } from "react";
import { useQuery } from "react-query";
import * as api from "../services";
import AppContext from "../appContext";

const initInteractions = [];

export default function useInteraction(props) {
  const {
    app: {
      client: { id: contextId },
      project: { id: projectId },
      pauseQueries,
      sessionId,
    },
  } = useContext(AppContext);
  const clientId = props?.id ?? contextId;
  const {
    data: interactions,
    isLoading: isInteractionLoading,
    isError: isInteractionError,
    refetch: refetchInteractions,
  } = useQuery(
    ["surveys", clientId, projectId, sessionId],
    () =>
      api
        .getLocalInteractions({ clientId, projectId, sessionId })
        .then((data) => data?.list ?? initInteractions)
        .then((list) =>
          list.map((obj) => {
            const id = obj.id ?? Math.round(Math.random() * 10000000);
            const name = obj.name ?? "No title";
            const interactionType = obj.interactionType ?? 0;
            return { id, name, interactionType };
          })
        ),
    {
      placeholderData: () => initInteractions,
      enabled: clientId !== -1 && !pauseQueries,
    }
  );

  return {
    interactions,
    isInteractionLoading,
    isInteractionError,
    refetchInteractions,
  };
}
